import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Skeleton } from '@atlassian/mpac-ui';
import React from 'react';
import { PricingDescription } from '../PricingTab.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const PricingTierRowSkeleton = /*#__PURE__*/_styled(Skeleton.Row, {
  target: "e173veia0",
  label: "PricingTierRowSkeleton"
})(process.env.NODE_ENV === "production" ? {
  name: "1tyndxa",
  styles: "justify-content:center;"
} : {
  name: "1tyndxa",
  styles: "justify-content:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * Renders the loading state of the pricing tab tiers as a "skeleton" or "shimmer"
 */
const PricingTiersSkeleton = _ref => {
  let {
    showServerEolMessage
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!showServerEolMessage ? /*#__PURE__*/_jsx(PricingDescription, {
      children: /*#__PURE__*/_jsx(Skeleton.Block, {
        width: 400,
        height: 20
      })
    }) : null, /*#__PURE__*/_jsxs(PricingTierRowSkeleton, {
      children: [/*#__PURE__*/_jsx(Skeleton.Block, {
        width: 150,
        height: 150,
        marginRight: 10
      }), /*#__PURE__*/_jsx(Skeleton.Block, {
        width: 150,
        height: 150,
        marginRight: 10
      }), /*#__PURE__*/_jsx(Skeleton.Block, {
        width: 150,
        height: 150,
        marginRight: 10
      }), /*#__PURE__*/_jsx(Skeleton.Block, {
        width: 150,
        height: 150,
        marginRight: 10
      }), /*#__PURE__*/_jsx(Skeleton.Block, {
        width: 150,
        height: 150,
        marginRight: 10
      })]
    }), /*#__PURE__*/_jsx(PricingTierRowSkeleton, {
      children: /*#__PURE__*/_jsx(Skeleton.Block, {
        width: "70%",
        height: 50,
        marginTop: 30
      })
    })]
  });
};
export default PricingTiersSkeleton;